import Vue from "vue";
import Component from "vue-class-component";
import { MedicalInvoice } from "@/components/medicalTransmissionEdit/types";
import { Prop } from "vue-property-decorator";

@Component
export default class MedicalInvoiceBase extends Vue {
  @Prop() tab!: MedicalInvoice;

  //保険適用負担削除
  deleteInsIn(index: number) {
    if (
      window.confirm(
        "「" +
          this.tab.burden_ins_ins[index].item +
          "」を削除します。よろしいですか？"
      )
    ) {
      this.tab.burden_ins_ins.splice(index, 1);
    }
  }

  //保険適用負担追加
  addInsIn() {
    const length = this.tab.burden_ins_ins.length;
    this.tab.burden_ins_ins.push({
      id: 0,
      medical_invoice_id: this.tab.id,
      patient_id: 0,
      office_id: 0,
      yearmonth: this.tab.yearmonth,
      order: length,
      item: "",
      unit_price: 0,
      unit_num: 0,
      total_money: 0,
      created_at: null,
      updated_at: null,
      deleted_at: null
    });
  }

  //保険適用負担更新
  updateTotalIns() {
    this.tab.ins_cost_total_org = Math.floor(this.getTotalIns());
    this.tab.ins_cost_total = Math.round(this.tab.ins_cost_total_org / 10) * 10;
    this.tab.cost_total = this.tab.ins_cost_total + this.tab.self_cost_total;
  }

  //保険適用負担
  getTotalIns(): number {
    const ins_const_total = this.tab.burden_ins_ins.reduce(
      (ac, cu) => ac + cu.total_money,
      0
    );
    if (this.tab.is_self_burden) {
      //上限あり(負担割合が0の場合、10割として計算する)
      let burden = this.tab.burden_rate;
      if (!burden) {
        burden = 10;
      }
      if ((ins_const_total * burden) / 10 > this.tab.self_burden!!) {
        return this.tab.self_burden!!;
      }
    }
    return (ins_const_total * this.tab.burden_rate) / 10;
  }
}
